import { store } from '@/decorators/store';
import { Trip } from '@/entities/Trip';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'TripStore' })
export class TripStore extends AbstractEntityStore<Trip> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'name';
  protected entityValueKey = 'name';

  // Bumped by TripManager.scheduleNextLeadTimeCheck() to trigger reactive
  // re-evaluation of getPendingAssignments when a trip crosses the lead time threshold.
  leadTimeTick: number = 0;
}
